import { render } from "./DriverAdmin.vue?vue&type=template&id=2d7476f6"
import script from "./DriverAdmin.vue?vue&type=script&lang=js"
export * from "./DriverAdmin.vue?vue&type=script&lang=js"
script.render = render

export default script